const Form022EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },
    importantNotesContent: {
        title: "Notes",
        boldTextP: "Reference Materials:",
        p1: "EDB Circular Nos. {{circularNoPrimary}} (NET Scheme in Primary Schools) ",
        primarySchoolWebsite:
            "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/relocation%20of%20office_18%20Sept%202021/EDBC09008E_R.pdf",
        p2: "EDB Circular Nos. {{circularNoSecondary}} (Enhanced NET Scheme in Secondary Schools) ",
        secondarySchoolWebsite:
            "https://www.edb.gov.hk/attachment/en/sch-admin/admin/about-sch-staff/net-scheme/relocation%20of%20office_18%20Sept%202021/EDBC09009E_R.pdf",
        p3: "Sample Memorandum on the Terms and Conditions of Service for Appointment as Teachers under the NET Scheme in Primary Schools / the Enhanced NET Scheme in Secondary Schools (applicable to {{schoolyear}} school year)",
        primarySchool1: "Primary Schools",
        primarySchool: "{{primarySchool}}",
        secondarySchool1: "Secondary Schools",
        secondarySchool: "{{secondarySchool}}",
    },
    applicationInformationContent: {
        formTypeOption: {
            primary:
                "Native-speaking English Teacher (NET) Scheme in Primary Schools Application for Advance of Salary",
            secondary:
                "Enhanced Native-speaking English Teacher (NET) Scheme in Secondary Schools Application for Advance of Salary",
        },

        schoolTypeOption: {
            aidedOrSpecialSchool: "Aided schools / Special schools",
            caputSchool: "Caput school",
        },

        conditionList: {
            a: "that I agree to repay the advanced salary by six equal monthly instalments commencing from the month following that in which I receive the advance;",
            b: "that all the repayments shall be deducted from my monthly salaries; and",
            c: "that if for any reason, my employment ceases with the school, I undertake to pay immediately the sum outstanding which may be deducted by the school from any further sums due to me or to my estate and in the event that the deduction is insufficient to cover the repayment, I will repay the lump sum of the remaining outstanding amount immediately.",
        },
        schoolHeadOption: {
            supervisor: "Supervisor",
            principal: "Principal",
        },
        label: {
            partOne: "PART I (To be completed by the NET)",
            selectText: "Please Select",
            aidedOrCaput: "School Financial Type",
            aidedOrCaputOption: {
                aided: "Aided schools / Special school",
                caput: "Caput school",
            },
            schoolNameBeforeText: "To: Supervisor/Principal of",
            schoolNameAfterText: "(School)",
            advanceBeforeText:
                "1. I wish to apply for an advance of salary in the amount of HK$",
            basicSalaryBeforeText: ". My basic salary is HK$",
            basicSalaryAfterText: "per month.",
            conditionsCheckBeforeText: "2. ",
            conditions: "I do hereby abide by the following conditions:",
            isConfirmBeforeText: "3. ",
            isConfirmPrimary:
                "I confirm that I have read and understood the EDB Circular No. {{circularNo}} including the Notes for Completing PNET-Forms A-E and the stipulations related to advance of salary in the Memorandum on the Terms and Conditions of Service.",
            isConfirmSecondary:
                "I confirm that I have read and understood the EDB Circular No. {{circularNo}} including the Notes for Completing NET-Forms A-E and the stipulations related to advance of salary in the Memorandum on the Terms and Conditions of Service.",
            hkid: "Hong Kong Identity Card Number (Mandatory to be provided once available)",
            givenName: "Given names",
            surname: "Surname",

            partTwo: "PART II ",
            partTwoTitle:
                "(To be completed by aided schools/special schools with {{formType}} section only)",
            fullNameBeforeText: "1. I certify that the applicant",
            fullNameAfterText: "(Full name) is:",
            employFromBeforeText: "(a) employed in my school from",
            employFromAfterText: "to",
            employToAfterText: "; and",
            employFrom: "From",
            employTo: "To",
            point1BText:
                "(b) on first appointment as a Native-speaking English Teacher under the {{school}}.",
            advancePart2BeforeText: "2. The grant of a salary advance of HK$",
            advancePart2AfterText:
                "is approved. I should be grateful if you would arrange the payment.",
            instalmentsBeforeText:
                "3. Please recover the advance by six equal monthly instalments of HK$",
            instalmentsAfterText: "each with effect from ",
            instalmentFromAfterText: "(month/year).",
            instalments: "",
            instalmentFrom: "from",
            schoolHead: "Supervisor / Principal",
            schoolHeadName: "Name of ",
            schoolHeadTitle: " Title of ",
            schoolName: "Name of School",
            schoolCode: "School Code",
            schoolFaxNo: "Fax No.",
            schoolAddress: "School Address",
            contactPersonTitle: "Contact Person Title",
            contactPersonName: "Contact Person Name for Enquiry",
            contactPersonTel: "Tel. No.",
            contactPersonPost: "Post of Contact Person",

            partThree: "PART III",
            partThreeTitle: " (To be completed and retained by caput schools)",
            partThreeTitlePrimary: "",
            advancePart3AfterText: "is approved.",
            instalmentsPart3BeforeText:
                "3. Repayment in six equal monthly instalments of HK$",
            instalmentsPart3AfterText: "each should be effected from",
            partFour: "PART IV",
            partFourTitle:
                " (To be completed by the Funds Section, the Education Bureau)",
        },
    },
    errorMsg: {
        schoolName: "School Name",
        advance: " advance of salary",
        lessThanBasicSalary:
            "This field must not be more than double of basic salary",
        lengthEqualsFour: "The length of this field must equal 4.",
    },
};
export default Form022EN;
